import { UseQueryResult } from '@tanstack/react-query'
import { ParkingCarListResData, getParkingCarList } from '@tmap-web-lib/remote-api-client/frontman'
import { AxiosError } from 'axios'
import { useAtomValue } from 'jotai/index'

import { mockHost } from '@/apis'
import { storageMockEnabled } from '@/atoms'
import { useQueryWrapper } from '@/hooks/useQueryWrapper'
import { KEYS } from '@/react-query/keys'

interface Props {
  useErrorBoundary?: boolean
}

function useGetParkingList(props: Props): UseQueryResult<ParkingCarListResData, AxiosError> {
  const storageMock = useAtomValue(storageMockEnabled)

  return useQueryWrapper<ParkingCarListResData, AxiosError>(
    KEYS.VEHICLE_PARKING(),
    async () => {
      if (storageMock) {
        const { data } = await mockHost.get('parking/member-api/v1/members/vehiclesList')
        return data
      } else {
        const { data } = await getParkingCarList()
        return data
      }
    },
    {
      useErrorBoundary: props?.useErrorBoundary ?? true,
    }
  )
}

export { useGetParkingList }
